export const USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST';
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const USER_LOGIN_FAIL = 'USER_LOGIN_FAIL';
export const USER_LOGOUT = 'USER_LOGOUT';

export const USER_REGISTER_REQUEST = 'USER_REGISTER_REQUEST';
export const USER_REGISTER_SUCCESS = 'USER_REGISTER_SUCCESS';
export const USER_REGISTER_FAIL = 'USER_REGISTER_FAIL';

export const USER_GOOGLE_LOGIN_REQUEST = 'USER_GOOGLE_LOGIN_REQUEST';
export const USER_GOOGLE_LOGIN_SUCCESS = 'USER_GOOGLE_LOGIN_SUCCESS';
export const USER_GOOGLE_LOGIN_FAIL = 'USER_GOOGLE_LOGIN_FAIL';

export const USER_DETAILS_REQUEST = 'USER_DETAILS_REQUEST';
export const USER_DETAILS_SUCCESS = 'USER_DETAILS_SUCCESS';
export const USER_DETAILS_FAIL = 'USER_DETAILS_FAIL';
export const USER_DETAILS_RESET = 'USER_DETAILS_RESET';

export const USER_UPDATE_PROFILE_REQUEST = 'USER_UPDATE_PROFILE_REQUEST';
export const USER_UPDATE_PROFILE_SUCCESS = 'USER_UPDATE_PROFILE_SUCCESS';
export const USER_UPDATE_PROFILE_FAIL = 'USER_UPDATE_PROFILE_FAIL';
export const USER_UPDATE_PROFILE_RESET = 'USER_UPDATE_PROFILE_RESET';

export const USER_LIST_ADMIN_REQUEST = 'USER_LIST_ADMIN_REQUEST';
export const USER_LIST_ADMIN_SUCCESS = 'USER_LIST_ADMIN_SUCCESS';
export const USER_LIST_ADMIN_FAIL = 'USER_LIST_ADMIN_FAIL';
export const USER_LIST_ADMIN_RESET = 'USER_LIST_ADMIN_RESET';

export const USER_DELETE_ADMIN_REQUEST = 'USER_DELETE_ADMIN_REQUEST';
export const USER_DELETE_ADMIN_SUCCESS = 'USER_DELETE_ADMIN_SUCCESS';
export const USER_DELETE_ADMIN_FAIL = 'USER_DELETE_ADMIN_FAIL';

export const USER_UPDATE_ADMIN_REQUEST = 'USER_UPDATE_ADMIN_REQUEST';
export const USER_UPDATE_ADMIN_SUCCESS = 'USER_UPDATE_ADMIN_SUCCESS';
export const USER_UPDATE_ADMIN_FAIL = 'USER_UPDATE_ADMIN_FAIL';
export const USER_UPDATE_ADMIN_RESET = 'USER_UPDATE_ADMIN_RESET';
